// extracted by mini-css-extract-plugin
export default {"container":"us-z","heading":"vs-z","text":"ws-z","info":"xs-z","link":"ys-z","fullMaxWidth":"zs-z"};